export function getKeyByValue<T extends object>(obj: T, value: any): keyof T | undefined {
    const keys = Object.keys(obj) as (keyof T)[];
    return keys.find(k => obj[k] === value);
}
